import { FC } from "react";

import { formatMoney } from "lib/helpers";

interface PayloadItem {
  dataKey: string;
  value: number;
  payload: {
    x: number;
    y: number;
  };
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: PayloadItem[];
  label?: string;
}

export const CustomTooltip: FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  if (active) {
    const total: number = payload[0].payload.y;
    return (
      <div className="custom-tooltip">
        {label && <p>{label}</p>}
        <p>{`Total: $${formatMoney(total, 0)}`}</p>
        {payload.map(item => (
          <p key={`item-${item.dataKey}`}>{`${item.dataKey}: $${formatMoney(
            item.value,
            0,
          )}`}</p>
        ))}
      </div>
    );
  }
  return null;
};
